import React, { PureComponent } from 'react'
import classnames from 'classnames'

export default class UserActivityListener extends PureComponent {

	static defaultProps = {
		delay: 3,
		defaultActive: false
	}

	constructor(props) {

		super(props)

		this.state = {
			isUserActive: false
		}
		this.onMouseMove = this.onMouseMove.bind(this)
	}

	componentWillUnmount() {
		window.removeEventListener('mousemove', this.onMouseMove)
		this.clearMouseTimer()
	}
	
	componentDidMount() {
		window.addEventListener('mousemove', this.onMouseMove)
		this.setState({
			isUserActive: this.props.defaultActive
		})
		this.mouseMoveTimeout = setTimeout(() => {
			this.props.onChange && this.props.onChange(true)
		}, this.props.delay * 1000 * 2)
	}

	onMouseMove() {
		
		if ( this.state.isUserActive !== true ) {
			this.props.onChange && this.props.onChange(false)
		}
		this.setState({
			isUserActive: true
		})
		this.clearMouseTimer()
		this.mouseMoveTimeout = setTimeout(() => {
			this.onMouseTimer()
		}, this.props.delay * 1000)
	}

	onMouseTimer() {
		this.clearMouseTimer()
		if ( this.state.isUserActive !== false ) {
			this.props.onChange && this.props.onChange(true)
		}
		this.setState({
			isUserActive: false
		})
	}

	clearMouseTimer() {
		if (this.mouseMoveTimeout) {
			clearTimeout(this.mouseMoveTimeout)
			this.mouseMoveTimeout = null
		}
	}

	render() {
		var classes = classnames('user-activity', {
			'user-active': this.state.isUserActive,
			'user-inactive': !this.state.isUserActive
		})
		var child = React.cloneElement(this.props.children,
			Object.assign({}, this.props, {
				isUserActive: this.state.isUserActive
			})
		)
		return <div className={classes}>{child}</div>
	}
}



// WEBPACK FOOTER //
// ./src/components/player/util/UserActivityListener.jsx